import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectMembersFetched, {
	type SubjectMemberPayload,
	type SubjectMembersFetchedAction,
} from '@Application/Subjects/Members/Actions/subjectMembersFetched';
import subjectMembersFetchFailed, {
	type SubjectMembersFetchFailedAction,
} from '@Application/Subjects/Members/Actions/subjectMembersFetchFailed';
import type FetchSubjectMembers from '@Application/Subjects/Members/Queries/FetchSubjectMembers';
import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = SubjectMembersFetchedAction | SubjectMembersFetchFailedAction;

export default (query: FetchSubjectMembers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const members = await get<SubjectMemberPayload[]>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/members`,
			);

			const action = subjectMembersFetched(query.subject.subjectId, members, query.subject.typeKey);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectMembersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
